angular.module('iqxCore')
.controller('ActionDialogLegacyCandidateDocumentsCtrl', function ($scope, FormSvc, $http, LanguageSvc) {
	var lang = LanguageSvc.lang
	FormSvc.setOptions($scope,{
		fetchAPI:'callresult/NetCandidateDocumentsFiltered?pPersonID='+$scope.ActionDialog.obj.linkID,
		fetchTarget:'documents',
		multiRow:true
	})

    $scope.download=function(doc){
    	/* Triggers the download */
    	$scope.getFile(doc, 'download')
    }

    $scope.view=function(doc){
    	$scope.viewTitle=doc.DocDescription||""
    	$scope.getFile(doc, 'view')
    }

	$scope.getFile=function(doc, method) {
		$http.get('/api/document/doxi',{params:{id:doc.DocumentID,personid:doc.PersonID,type:doc.SpecialType}})
    	.then(function(res){
    		$http.get('/api/document/download?doxi='+res.data)
				.then(function(success){
    			switch(method){
    				case 'download':
						var _newTab = window.open('about:blank', '_blank')
						setTimeout(function () { // wait a second then fill that blank tab - thus stopping that pesky popup blocker!!
							_newTab.location.href = '/api/document/download?doxi='+res.data
						}, 1001)
    				break

    				case 'view':
						$scope.documentContent = '/api/document/download?doxi='+res.data
						FormSvc.modalInfo($scope,'viewDocument',{choices:[{desc:"Close",type:"primary",code:''}]}, 'lg')
    				break
    			}
				}, function(err){
					FormSvc.alert("Error", err.data, "error")
				})
		})
		.catch(function(err) {
			FormSvc.alert("Error", err.data, "error")
		})
	}

	$scope.fetch()
})
